
import dayjs from "dayjs";
import PAAttendee from "./Attendee";


class Note {
    constructor(){

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;
        this.created = dayjs().utc().format();

        this.note = "";
        this.attendee_id = "";
        this.date = "";
        this.day = "";
        this.private = false;
        this.priority = "low";      //low, medium, high
        this.tagged = [];           //this is an array of attendee ids

        this.status = 0;
    }
}

export default Note;
